<script setup>
import { trans } from '../../../../_00_elements/translation';
import SubscriptionDetailsSection from './SubscriptionDetailsSection.vue';
import SubscriptionDetailsValue from './SubscriptionDetailsValue.vue';
import useSubscriptionStore from '../../store/subscriptions';
import PhoneNumber from '../../../../_00_elements/tools/phoneNumber';

// eslint-disable-next-line camelcase
const { client_name, client } = useSubscriptionStore().selectedSubscriptionData;
</script>

<template>
  <SubscriptionDetailsSection>
    <template #details>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.buyer.organization_name')" :value="client.legal_name" />
      <SubscriptionDetailsValue :label="trans('gestion.subscription.buyer.contact')">
        <template v-if="client_name">
          {{ client_name }}<br>
        </template>
        <template v-if="client.email">
          {{ client.email }}<br>
        </template>
        <template v-if="client.phone_number">
          {{ new PhoneNumber(client.phone_number).printFormattedNational }}
        </template>
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.buyer.address')">
        {{ client.street_and_number }}
        <template v-if="client.additional_info">
          {{ client.additional_info }}
        </template>
        {{ client.zip_code }} {{ client.city }}
      </SubscriptionDetailsValue>
    </template>
  </SubscriptionDetailsSection>
</template>
